import { useEffect, useRef, useState } from 'react';

import { ContentLoader } from '~/components/ContentLoader.tsx';

import { useMockingSetting } from './useMockingSetting.ts';

async function enableMocking() {
  if (process.env.VITEST) {
    // In production & testing, we don't want to enable mocking
    return;
  }

  const { worker } = await import('../../api/msw/browser.ts');

  return worker.start();
}

async function disableMocking() {
  if (process.env.VITEST) {
    // In production & testing, we don't want to disable mocking
    return;
  }

  const { worker } = await import('../../api/msw/browser.ts');

  worker.stop();
}

export const ServerMockingProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [loading, setLoading] = useState(true);
  const { serverMocking } = useMockingSetting();

  const mockingEnabled = useRef<boolean>(false);

  useEffect(() => {
    if (serverMocking && !mockingEnabled.current) {
      mockingEnabled.current = true;
      enableMocking()
        .catch((error: unknown) => {
          console.error('Failed to start service worker:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (!serverMocking && mockingEnabled.current) {
      mockingEnabled.current = false;
      disableMocking()
        .catch((error: unknown) => {
          console.error('Failed to stop service worker:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoading(false);
    }
  }, [serverMocking]);

  return <>{loading ? <ContentLoader testID="mocking-loader" /> : children}</>;
};
